(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mp-apollo-parts"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.mp-apollo-parts').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const modelSelect = root.querySelector('[data-model-select]');
      const categorySelect = root.querySelector('[data-category-select]');
      const filterInput = root.querySelector('[data-parts-filter]');
      const status = root.querySelector('[data-status]');
      const catalog = root.querySelector('[data-catalog]');
      const categoryNav = root.querySelector('[data-category-nav]');
      const modelName = root.querySelector('[data-model-name]');
      const categoryTitle = root.querySelector('[data-category-title]');
      const partCount = root.querySelector('[data-part-count]');
      const image = root.querySelector('[data-category-image]');
      const partsList = root.querySelector('[data-parts-list]');
      const partTemplate = root.querySelector('[data-part-template]');
      const imageDialog = root.querySelector('[data-image-dialog]');
      const dialogImage = root.querySelector('[data-dialog-image]');
      const labels = JSON.parse(root.querySelector('[data-labels]').textContent);
      let models = [];
      let currentModel = null;
      let currentCategory = null;

      const normalize = (value) => String(value || '').toLocaleLowerCase();
      const productHandle = (sku) => `apollo-${String(sku || '').trim().toLocaleLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`;
      const productUrl = (sku) => `${root.dataset.productsUrl}${productHandle(sku)}`;

      const setUrl = () => {
        if (!currentModel) return;
        const url = new URL(window.location.href);
        url.searchParams.set('modele', currentModel.handle);
        if (currentCategory) url.searchParams.set('categorie', String(currentModel.categories.indexOf(currentCategory)));
        window.history.replaceState({}, '', url);
      };

      const countLabel = (count) => `${count} ${count === 1 ? labels.countOne : labels.countOther}`;

      const renderParts = () => {
        if (!currentCategory) return;
        const term = normalize(filterInput.value.trim());
        const parts = currentCategory.parts.filter((part) => {
          if (!term) return true;
          return normalize(`${part.number} ${part.name} ${part.sku}`).includes(term);
        });
        partsList.replaceChildren();
        partCount.textContent = countLabel(parts.length);

        if (!parts.length) {
          const empty = document.createElement('p');
          empty.textContent = labels.noResults;
          partsList.append(empty);
          return;
        }

        const fragment = document.createDocumentFragment();
        parts.forEach((part) => {
          const card = partTemplate.content.cloneNode(true);
          card.querySelector('[data-part-number]').textContent = part.number || '—';
          card.querySelector('[data-part-name]').textContent = part.name;
          card.querySelector('[data-part-sku]').textContent = part.sku;
          card.querySelector('[data-part-price]').textContent = part.retail || '';
          const partUrl = productUrl(part.sku);
          const thumbnail = card.querySelector('[data-part-image]');
          thumbnail.src = String(part.image || '').startsWith('http') ? part.image : root.dataset.placeholderUrl;
          thumbnail.alt = part.name;
          card.querySelector('[data-part-image-link]').href = partUrl;
          const link = card.querySelector('[data-part-link]');
          link.href = partUrl;
          const addButton = card.querySelector('[data-add-part]');
          addButton.addEventListener('click', async () => {
            addButton.disabled = true;
            addButton.textContent = labels.adding;
            try {
              const productResponse = await fetch(`${partUrl}.js`);
              if (!productResponse.ok) throw new Error('unavailable');
              const product = await productResponse.json();
              const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
              if (!variant?.id || variant.available === false) throw new Error('unavailable');
              const cartResponse = await fetch(root.dataset.cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
              });
              if (!cartResponse.ok) throw new Error('cart');
              addButton.textContent = labels.added;
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            } catch (error) {
              addButton.textContent = error.message === 'unavailable' ? labels.unavailable : labels.cartError;
            } finally {
              window.setTimeout(() => {
                addButton.disabled = false;
                addButton.textContent = labels.addToCart;
              }, 2200);
            }
          });
          fragment.append(card);
        });
        partsList.append(fragment);
      };

      const chooseCategory = (index) => {
        currentCategory = currentModel?.categories[index] || currentModel?.categories[0];
        if (!currentCategory) return;
        categorySelect.value = String(currentModel.categories.indexOf(currentCategory));
        categoryTitle.textContent = currentCategory.title;
        image.src = currentCategory.image;
        image.alt = `${currentModel.name} — ${currentCategory.title}`;
        dialogImage.src = currentCategory.image;
        dialogImage.alt = image.alt;
        categoryNav.querySelectorAll('button').forEach((button, buttonIndex) => {
          button.classList.toggle('is-active', buttonIndex === currentModel.categories.indexOf(currentCategory));
          button.setAttribute('aria-current', buttonIndex === currentModel.categories.indexOf(currentCategory) ? 'true' : 'false');
        });
        filterInput.value = '';
        renderParts();
        setUrl();
      };

      const chooseModel = (handle) => {
        currentModel = models.find((model) => model.handle === handle) || models[0];
        if (!currentModel) return;
        modelSelect.value = currentModel.handle;
        modelName.textContent = currentModel.name;
        categorySelect.replaceChildren();
        categoryNav.replaceChildren();
        currentModel.categories.forEach((category, index) => {
          const option = new Option(category.title, String(index));
          categorySelect.add(option);
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = category.title;
          button.addEventListener('click', () => chooseCategory(index));
          categoryNav.append(button);
        });
        categorySelect.disabled = false;
        filterInput.disabled = false;
        const params = new URLSearchParams(window.location.search);
        chooseCategory(Number(params.get('categorie')) || 0);
        status.hidden = true;
        catalog.hidden = false;
      };

      modelSelect.addEventListener('change', () => chooseModel(modelSelect.value));
      categorySelect.addEventListener('change', () => chooseCategory(Number(categorySelect.value)));
      filterInput.addEventListener('input', renderParts);
      root.querySelector('[data-open-image]').addEventListener('click', () => imageDialog.showModal());
      root.querySelector('[data-close-image]').addEventListener('click', () => imageDialog.close());
      imageDialog.addEventListener('click', (event) => {
        if (event.target === imageDialog) imageDialog.close();
      });

      fetch(root.dataset.catalogUrl)
        .then((response) => {
          if (!response.ok) throw new Error(String(response.status));
          return response.json();
        })
        .then((data) => {
          models = data.models || [];
          modelSelect.replaceChildren(new Option(labels.modelsPlaceholder, ''));
          models.forEach((model) => modelSelect.add(new Option(model.name, model.handle)));
          modelSelect.disabled = false;
          const requested = new URLSearchParams(window.location.search).get('modele');
          if (requested && models.some((model) => model.handle === requested)) chooseModel(requested);
          else status.textContent = labels.modelsPlaceholder;
        })
        .catch(() => {
          status.textContent = labels.error;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-apollo-vehicles"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const swatch=event.target.closest('.mp-vehicle__swatch');if(!swatch)return;const vehicle=swatch.closest('[data-vehicle]');if(!vehicle)return;vehicle.querySelectorAll('.mp-vehicle__swatch').forEach(button=>button.classList.remove('is-active'));swatch.classList.add('is-active');const nextImage=swatch.dataset.image;if(!nextImage)return;const image=vehicle.querySelector('.mp-vehicle__image');if(!image)return;image.style.opacity='0';setTimeout(()=>{image.src=nextImage;image.removeAttribute('srcset');image.style.opacity='1'},120)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-riding-times-vehicles"] && !Shopify.designMode) return;
  try {
    
(function(){const lang='{{ request.locale.iso_code }}';const T=lang==='en'?{fill:'Complete all fields to get a recommendation.',none:'No model in this category matches the entered height and maximum load.',best:'Best estimated match',view:'View this model',why:'Height and rider weight fit the published range for this model.',skill:'The selected experience level is below the performance level of this model; progress gradually and verify real-world control.',age:'Age is kept as a secondary reference because no fixed manufacturer age range is used here.',max:'Max load'}:{fill:'Remplissez tous les champs pour obtenir une recommandation.',none:'Aucun modèle de cette catégorie ne correspond à la taille et à la charge maximale indiquées.',best:'Meilleur match estimé',view:'Voir ce modèle',why:'La taille et le poids du pilote respectent la plage publiée pour ce modèle.',skill:'Le niveau d’expérience choisi est inférieur au niveau de performance de ce modèle; progressez graduellement et validez le contrôle réel.',age:'L’âge demeure un repère secondaire puisqu’aucune plage d’âge fixe du fabricant n’est utilisée ici.',max:'Charge max'};document.querySelectorAll('[data-rt-finder]').forEach(function(root){if(root.dataset.ready)return;root.dataset.ready='1';const form=root.querySelector('[data-finder-form]'),result=root.querySelector('[data-finder-result]'),opts=[...root.querySelectorAll('.mp-rt-finder-option')],buttons=[...root.querySelectorAll('[data-unit-toggle]')];let units='metric';const val=s=>{const e=root.querySelector(s);if(!e)return null;const n=parseFloat(e.value);return Number.isFinite(n)?n:null};const num=(o,k)=>{const n=parseFloat(o.dataset[k]||'');return Number.isFinite(n)?n:null};const esc=s=>String(s||'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));const kgToLb=k=>k*2.2046226218,lbToKg=l=>l/2.2046226218;function height(){if(units==='metric')return val('[data-height-cm]');const f=val('[data-height-ft]'),i=val('[data-height-in]');if(f===null&&i===null)return null;return ((f||0)*12+(i||0))*2.54}function weight(){if(units==='metric')return val('[data-weight-kg]');const l=val('[data-weight-lb]');return l===null?null:lbToKg(l)}function setUnits(next,convert){if(convert&&next!==units){if(next==='imperial'){const cm=val('[data-height-cm]'),kg=val('[data-weight-kg]');if(cm!==null){const total=cm/2.54,ft=Math.floor(total/12);root.querySelector('[data-height-ft]').value=ft;root.querySelector('[data-height-in]').value=Math.round((total-ft*12)*2)/2}if(kg!==null)root.querySelector('[data-weight-lb]').value=kgToLb(kg).toFixed(1)}else{const f=val('[data-height-ft]'),i=val('[data-height-in]'),lb=val('[data-weight-lb]');if(f!==null||i!==null)root.querySelector('[data-height-cm]').value=Math.round(((f||0)*12+(i||0))*2.54);if(lb!==null)root.querySelector('[data-weight-kg]').value=lbToKg(lb).toFixed(1)}}units=next;root.querySelectorAll('[data-unit-field]').forEach(e=>e.hidden=e.dataset.unitField!==units);buttons.forEach(b=>{const a=b.dataset.unitToggle===units;b.classList.toggle('is-active',a);b.setAttribute('aria-pressed',a?'true':'false')})}function render(){const age=val('[data-age]'),h=height(),w=weight(),exp=parseInt(root.querySelector('[data-experience]').value,10);if(age===null||h===null||w===null||!exp){result.hidden=false;result.className='mp-rt-finder__result is-empty';result.innerHTML='<strong>'+esc(T.fill)+'</strong>';return}const viable=[];opts.forEach((o,index)=>{const min=num(o,'minHeight'),max=num(o,'maxHeight'),load=num(o,'maxLoad'),skill=num(o,'skill')||2;if(h<min||h>max||w>load)return;const mid=(min+max)/2,half=Math.max((max-min)/2,1);let score=100-Math.abs(h-mid)/half*18;if(skill>exp)score-=(skill-exp)*28;else if(exp===skill)score+=8;const ratio=w/load;if(ratio>.9)score-=10;else if(ratio<.75)score+=3;viable.push({o,score,index,min,max,load,skill})});viable.sort((a,b)=>b.score-a.score||a.index-b.index);if(!viable.length){result.hidden=false;result.className='mp-rt-finder__result is-empty';result.innerHTML='<strong>'+esc(T.none)+'</strong>';return}const b=viable[0],o=b.o;let why=T.why+' '+T.age;if(b.skill>exp)why+=' '+T.skill;const load=units==='metric'?Math.round(b.load)+' kg':Math.round(kgToLb(b.load))+' lb';const range=units==='metric'?Math.round(b.min)+'–'+Math.round(b.max)+' cm':(()=>{const fmt=cm=>{const total=cm/2.54,ft=Math.floor(total/12),inch=Math.round(total-ft*12);return ft+(lang==='en'?' ft ':' pi ')+inch+(lang==='en'?' in':' po')};return fmt(b.min)+' – '+fmt(b.max)})();result.hidden=false;result.className='mp-rt-finder__result';result.innerHTML='<div class="mp-rt-result-grid">'+(o.dataset.image?'<img src="'+esc(o.dataset.image)+'" alt="">':'')+'<div><p class="mp-rt-result-kicker">'+esc(T.best)+'</p><h3>'+esc(o.dataset.title)+'</h3><p>'+esc(why)+'</p><div class="mp-rt-result-chips"><span>'+esc(range)+'</span><span>'+esc(T.max)+' '+esc(load)+'</span><span>'+esc(o.dataset.power)+'</span><span>'+esc(o.dataset.battery)+'</span></div><a href="'+esc(o.dataset.url)+'">'+esc(T.view)+' →</a></div></div>'}form.addEventListener('submit',e=>{e.preventDefault();render()});buttons.forEach(b=>b.addEventListener('click',()=>setUnits(b.dataset.unitToggle,true)));setUnits('metric',false)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-rt-parts"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.mp-rt-parts').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const modelSelect = root.querySelector('[data-model-select]');
      const categorySelect = root.querySelector('[data-category-select]');
      const filterInput = root.querySelector('[data-parts-filter]');
      const status = root.querySelector('[data-status]');
      const catalog = root.querySelector('[data-catalog]');
      const categoryNav = root.querySelector('[data-category-nav]');
      const modelName = root.querySelector('[data-model-name]');
      const categoryTitle = root.querySelector('[data-category-title]');
      const partCount = root.querySelector('[data-part-count]');
      const image = root.querySelector('[data-category-image]');
      const partsList = root.querySelector('[data-parts-list]');
      const partTemplate = root.querySelector('[data-part-template]');
      const imageDialog = root.querySelector('[data-image-dialog]');
      const dialogImage = root.querySelector('[data-dialog-image]');
      const labels = JSON.parse(root.querySelector('[data-labels]').textContent);
      let models = [];
      let currentModel = null;
      let currentCategory = null;

      const normalize = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const productHandle = (sku) => String(sku || '').toLowerCase();
      const productUrl = (sku) => `${root.dataset.productsUrl}${productHandle(sku)}`;

      const setUrl = () => {
        if (!currentModel) return;
        const url = new URL(window.location.href);
        url.searchParams.set('modele', currentModel.handle);
        if (currentCategory) url.searchParams.set('categorie', String(currentModel.categories.indexOf(currentCategory)));
        window.history.replaceState({}, '', url);
      };

      const countLabel = (count) => `${count} ${count === 1 ? labels.countOne : labels.countOther}`;

      const renderParts = () => {
        if (!currentCategory) return;
        const term = normalize(filterInput.value.trim());
        const parts = currentCategory.parts.filter((part) => {
          if (!term) return true;
          return normalize(`${part.number} ${part.name} ${part.sku}`).includes(term);
        });
        partsList.replaceChildren();
        partCount.textContent = countLabel(parts.length);

        if (!parts.length) {
          const empty = document.createElement('p');
          empty.textContent = labels.noResults;
          partsList.append(empty);
          return;
        }

        const fragment = document.createDocumentFragment();
        parts.forEach((part) => {
          const card = partTemplate.content.cloneNode(true);

          card.querySelector('[data-part-name]').textContent = part.name;
          card.querySelector('[data-part-sku]').textContent = part.sku;
          card.querySelector('[data-part-price]').textContent = part.retail || '';
          const partUrl = productUrl(part.sku);
          const thumbnail = card.querySelector('[data-part-image]');
          if (part.image) thumbnail.src = part.image;
          else { thumbnail.remove(); const fallback = document.createElement('span'); fallback.textContent = part.sku; fallback.className = 'mp-rt-parts__no-image'; card.querySelector('[data-part-image-link]').append(fallback); }
          thumbnail.alt = part.is_placeholder ? `${part.name} — Image à venir / Image coming soon` : part.name;
          card.querySelector('[data-part-image-link]').href = partUrl;
          const link = card.querySelector('[data-part-link]');
          link.href = partUrl;
          const addButton = card.querySelector('[data-add-part]');
          const priceLabel = card.querySelector('[data-part-price]');
          // Variant IDs are generated from verified Shopify catalog records.
          // An inaccessible product .js endpoint (e.g., password-protected
          // theme preview) must never be interpreted as "sold out".
          const catalogVariantId = Number(part.variant_id);
          const hasVariant = Number.isSafeInteger(catalogVariantId) && catalogVariantId > 0;
          let soldOut = false;

          addButton.disabled = !hasVariant;
          if (!hasVariant) addButton.textContent = labels.unavailable;

          if (hasVariant) {
            fetch(`${partUrl}.js`, { credentials: 'same-origin' })
              .then((response) => {
                if (!response.ok) throw new Error('product_fetch_failed');
                return response.json();
              })
              .then((product) => {
                const variant = product.variants?.find((item) => Number(item.id) === catalogVariantId);
                if (variant) {
                  soldOut = variant.available === false;
                  addButton.disabled = soldOut;
                  addButton.textContent = soldOut ? labels.unavailable : labels.addToCart;
                }
                if (Number.isFinite(product.price) && product.price >= 0) {
                  priceLabel.textContent = new Intl.NumberFormat(root.dataset.locale, {
                    style: 'currency',
                    currency: window.Shopify?.currency?.active || 'CAD'
                  }).format(product.price / 100);
                }
              })
              .catch(() => {
                // The PDF-backed catalog price and verified variant ID remain visible.
                // Leave add-to-cart enabled; Shopify validates stock on cart/add.
                if (!soldOut) {
                  addButton.disabled = false;
                  addButton.textContent = labels.addToCart;
                }
              });
          }

          addButton.addEventListener('click', async () => {
            if (!hasVariant || soldOut) return;
            addButton.disabled = true;
            addButton.textContent = labels.adding;
            try {
              const cartResponse = await fetch(root.dataset.cartAddUrl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: catalogVariantId, quantity: 1 }] })
              });
              if (!cartResponse.ok) {
                if (cartResponse.status === 422) throw new Error('unavailable');
                throw new Error('cart');
              }
              addButton.textContent = labels.added;
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            } catch (error) {
              if (error.message === 'unavailable') soldOut = true;
              addButton.textContent = soldOut ? labels.unavailable : labels.cartError;
            } finally {
              window.setTimeout(() => {
                addButton.disabled = soldOut;
                addButton.textContent = soldOut ? labels.unavailable : labels.addToCart;
              }, 2200);
            }
          });
          fragment.append(card);
        });
        partsList.append(fragment);
      };

      const chooseCategory = (index) => {
        currentCategory = currentModel?.categories[index] || currentModel?.categories[0];
        if (!currentCategory) return;
        categorySelect.value = String(currentModel.categories.indexOf(currentCategory));
        categoryTitle.textContent = currentCategory.title;
        root.querySelector('[data-open-image]').hidden = !currentModel.diagram;
        root.querySelector('[data-diagram-note]').hidden = !currentModel.diagram;
        if(currentModel.diagram) image.src = currentModel.diagram; else image.removeAttribute('src');

        image.alt = `${currentModel.name} — Components diagram`;
        if(currentModel.diagram) dialogImage.src = currentModel.diagram; else dialogImage.removeAttribute('src');
        dialogImage.alt = image.alt;
        categoryNav.querySelectorAll('button').forEach((button, buttonIndex) => {
          button.classList.toggle('is-active', buttonIndex === currentModel.categories.indexOf(currentCategory));
          button.setAttribute('aria-current', buttonIndex === currentModel.categories.indexOf(currentCategory) ? 'true' : 'false');
        });
        filterInput.value = '';
        renderParts();
        setUrl();
      };

      const chooseModel = (handle) => {
        currentModel = models.find((model) => model.handle === handle) || models[0];
        if (!currentModel) return;
        modelSelect.value = currentModel.handle;
        modelName.textContent = currentModel.name;
        categorySelect.replaceChildren();
        categoryNav.replaceChildren();
        currentModel.categories.forEach((category, index) => {
          const option = new Option(category.title, String(index));
          categorySelect.add(option);
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = category.title;
          button.addEventListener('click', () => chooseCategory(index));
          categoryNav.append(button);
        });
        categorySelect.disabled = false;
        filterInput.disabled = false;
        const params = new URLSearchParams(window.location.search);
        chooseCategory(Number(params.get('categorie')) || 0);
        status.hidden = true;
        catalog.hidden = false;
      };

      modelSelect.addEventListener('change', () => { const url = new URL(location.href); url.searchParams.delete('categorie'); history.replaceState({}, '', url); chooseModel(modelSelect.value); });
      root.querySelector('[data-zoom]').addEventListener('input', e => { dialogImage.style.width = `${e.target.value}%`; });
      categorySelect.addEventListener('change', () => chooseCategory(Number(categorySelect.value)));
      filterInput.addEventListener('input', renderParts);
      root.querySelector('[data-open-image]').addEventListener('click', () => imageDialog.showModal());
      root.querySelector('[data-close-image]').addEventListener('click', () => imageDialog.close());
      imageDialog.addEventListener('click', (event) => {
        if (event.target === imageDialog) imageDialog.close();
      });

      fetch(root.dataset.catalogUrl)
        .then((response) => {
          if (!response.ok) throw new Error(String(response.status));
          return response.json();
        })
        .then((data) => {
          models = data.models || [];
          if (root.dataset.locale.startsWith('en')) models.forEach(m => m.categories.forEach(c => { c.title = c.title_en || c.title; }));
          modelSelect.replaceChildren(new Option(labels.modelsPlaceholder, ''));
          models.forEach((model) => modelSelect.add(new Option(model.name, model.handle)));
          modelSelect.disabled = false;
          const requested = new URLSearchParams(window.location.search).get('modele');
          if (requested && models.some((model) => model.handle === requested)) chooseModel(requested);
          else status.textContent = labels.modelsPlaceholder;
        })
        .catch(() => {
          status.textContent = labels.error;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
